import { VsInfiniteScroll } from '@vuesax-alpha/components/infinite-scroll'
import { VsLoading } from '@vuesax-alpha/components/loading'
import { VsNotification } from '@vuesax-alpha/components/notification'

import type { Plugin } from 'vue'

export default [VsInfiniteScroll, VsLoading, VsNotification] as Plugin[]
